<script>
import Badge from 'element-ui/lib/badge';

export default Badge;
</script>

<style lang="scss">
@import '~@/stylesheets/element-theme/badge.css';

.el-badge {
  &__content {
    border: 0;
  }
}
</style>
